// An employee's cut-off (no weekly submit): HR approves it, then exports it
export const CUTOFF_STATUS = {
  OPEN: { label: "Open", tone: "gray" },
  APPROVED: { label: "Approved", tone: "green" },
  EXPORTED: { label: "Processed", tone: "blue" }, // sent to payroll, locked
};

export const DAY_STATUS = {
  PRESENT: { label: "Present", tone: "green" },
  LATE: { label: "Late", tone: "amber" },
  ABSENT: { label: "Absent", tone: "red" },
  HALF_DAY: { label: "Half day", tone: "amber" },
  ON_LEAVE: { label: "On leave", tone: "blue" },
};

/** { year, month, cutoff } of a Period (what the DTR endpoints take). */
export const periodParams = (p) =>
  p ? { year: p.year, month: p.month, cutoff: p.cutoff } : null;
export const periodKey = (p) => (p ? `${p.year}-${p.month}-${p.cutoff}` : "");
export const parsePeriodKey = (key) => {
  const [year, month, cutoff] = String(key || "")
    .split("-")
    .map(Number);
  return year && month && cutoff !== undefined && !Number.isNaN(cutoff)
    ? { year, month, cutoff }
    : null;
};

export const fmtHours = (h) =>
  h === null || h === undefined ? "—" : `${Math.round(Number(h) * 100) / 100}`;

/** "5 days · 4 present · 1 late · 40h worked · 2h OT" for an employee row (zeros left out). */
export const totalsText = (t) => {
  if (!t || !Number(t.totalDays)) return "No time entries";
  const n = (v) => Number(v) || 0;
  const parts = [`${n(t.totalDays)} day${n(t.totalDays) === 1 ? "" : "s"}`];
  [
    [t.present, "present"],
    [t.late, "late"],
    [t.absent, "absent"],
    [t.halfDay, "half day"],
    [t.onLeave, "on leave"],
    [t.missingCheckOut, "missing check-out"],
  ].forEach(([v, label]) => n(v) && parts.push(`${n(v)} ${label}`));
  parts.push(`${fmtHours(n(t.totalWorkHours))}h worked`);
  if (n(t.totalOvertimeHours))
    parts.push(`${fmtHours(t.totalOvertimeHours)}h OT`);
  return parts.join(" · ");
};

/**
 * "Oct 10 – Oct 24, 2026 · Processed (12/12)", "… (current) · 0/14 processed",
 * or just the label when nobody is in it. progress: a /dtr/cutoff/progress row.
 */
export const periodOptionLabel = (label, isCurrent, progress) => {
  const base = `${label}${isCurrent ? " (current)" : ""}`;
  if (!progress || progress.state === "NONE" || !progress.total) return base;
  return progress.state === "PROCESSED"
    ? `${base} · Processed (${progress.processed}/${progress.total})`
    : `${base} · ${progress.processed}/${progress.total} processed`;
};
